module.exports = __webpack_public_path__ + "media/images/login/icon_facebook-d5a351f33ddf2caa302ad5809e0e900b.png";